import Quill from 'quill'

let Embed = Quill.import('blots/embed')
// a complex sentence that cannot be edited inline, only through popup
// this class is used to extend the dependency Quill
class SentenceBlot extends Embed {
	static create(sentence) {
		let node = super.create();
		this.sentence = sentence
		node.appendChild(sentence.getAsHtml())
		return node
	}

	static value() {
		return this.sentence
	}

	static deleteAt() {
		return
	}
}

SentenceBlot.blotName = 'sentence'
SentenceBlot.tagName = 'span'
SentenceBlot.className = 'sentence-blot-class'

export default SentenceBlot
